import {
  getQuestionInfo,
  saveQuestionnaire,
  saveComplaint
} from '@/api/complaint.js'

const state = {
}

const mutations = {
}

const actions = {
  getQuestionInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getQuestionInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveQuestionnaire({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveQuestionnaire(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveComplaint({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveComplaint(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
